import React, { Component } from 'react';
import './calendar.css';
import MeetingScheduler from './meetingScheduler';
import CalendarIcon from '../../assets/calendar-icon.svg';

class Calendar extends Component {
    constructor(props) {
        super(props);

        const currentDate = new Date();
        this.state = {
            selectedDate: null,
            currentMonth: currentDate.getMonth(),
            currentYear: currentDate.getFullYear(),
            isMobile: window.innerWidth < 768,
            calendar: true
        };
    }
    updateIsMobile() {
        this.setState({ isMobile: window.innerWidth < 768 });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateIsMobile);
    }

    componentDidMount() {
        this.updateIsMobile = this.updateIsMobile.bind(this); // Add this line
        window.addEventListener('resize', this.updateIsMobile);
    }

    handleDateClick = (date) => {
        const currentDate = new Date();
        if (date >= currentDate && date !== null) {
            this.setState({ selectedDate: date });
        }
        if (this.state.isMobile) {
            this.setState({
                calendar: false
            });
        }
    };

    handlePrevMonth = () => {
        const { currentMonth, currentYear } = this.state;
        let prevMonth = currentMonth - 1;
        let prevYear = currentYear;

        if (prevMonth < 0) {
            prevMonth = 11;
            prevYear--;
        }

        this.setState({
            currentMonth: prevMonth,
            currentYear: prevYear,
        });
    };

    handleNextMonth = () => {
        const { currentMonth, currentYear } = this.state;
        let nextMonth = currentMonth + 1;
        let nextYear = currentYear;

        if (nextMonth > 11) {
            nextMonth = 0;
            nextYear++;
        }

        this.setState({
            currentMonth: nextMonth,
            currentYear: nextYear,
        });
    };

    renderCalendar() {
        const { currentMonth, currentYear, selectedDate } = this.state;

        const currentDate = new Date();
        const currentDay = currentDate.getDate();
        const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
        const startDay = new Date(currentYear, currentMonth, 1).getDay();

        const calendar = [];
        const rows = Math.ceil((daysInMonth + startDay) / 7);

        for (let row = 0; row < rows; row++) {
            const cells = [];

            for (let day = 0; day < 7; day++) {
                const date = row * 7 + day - startDay + 1;
                const isCurrentMonth = date > 0 && date <= daysInMonth;
                const isPastDate = isCurrentMonth && new Date(currentYear, currentMonth, date) < currentDate;
                const isToday = isCurrentMonth && currentDay === date;
                const isSelected =
                    selectedDate &&
                    new Date(currentYear, currentMonth, date).getTime() === selectedDate.getTime();
                const isAccessible = isCurrentMonth && !isPastDate && date !== '';

                const cellClassName = `calendar-cell ${isCurrentMonth ? 'current-month' : 'other-month'} ${isPastDate ? 'past-date' : ''
                    } ${isToday ? 'today' : ''} ${isSelected ? 'selected-day' : ''} ${isAccessible ? 'accessible-date' : ''
                    }`;

                cells.push(
                    <td
                        key={day}
                        onClick={() =>
                            this.handleDateClick(isAccessible ? new Date(currentYear, currentMonth, date) : null)
                        }
                        className={cellClassName}
                    >
                        <span>{isCurrentMonth ? date : ''}</span>
                    </td>
                );
            }

            calendar.push(<tr key={row}>{cells}</tr>);
        }

        return calendar;
    }

    render() {
        const { currentMonth, currentYear, selectedDate, isMobile } = this.state;

        return (
            <div className={`meeting-container ${isMobile ? 'mobile' : ''}`}>
                {this.state.calendar && <div className="calendar">
                    <h1>Select Date & Time</h1>
                    <div className="month-year">
                        <div className={'date-desc'}>
                            <img src={CalendarIcon} alt="Calendar" />
                            <h2>
                                {new Date(currentYear, currentMonth).toLocaleString('default', {
                                    month: 'long',
                                    year: 'numeric',
                                })}
                            </h2>
                        </div>

                        <div>
                            <button onClick={this.handlePrevMonth}>&lt;</button>
                            <button onClick={this.handleNextMonth}>&gt;</button>
                        </div>
                    </div>

                    <table>
                        <thead>
                            <tr>
                                <th>Sun</th>
                                <th>Mon</th>
                                <th>Tue</th>
                                <th>Wed</th>
                                <th>Thu</th>
                                <th>Fri</th>
                                <th>Sat</th>
                            </tr>
                        </thead>
                        <tbody>{this.renderCalendar()}</tbody>
                    </table>
                </div>}

                {selectedDate && (
                    <div className={'schedular'}>
                        <MeetingScheduler selectedDate={selectedDate} />
                    </div>
                )}
            </div>
        );
    }
}

export default Calendar;
